// extracted by css-extract-rspack-plugin
export default {"HeaderTitleContainer":"Av5mD","HeaderTitle":"hm6LV"};